import axios from "axios";
import React, { useEffect } from "react";
import logo from "../../assets/logos/newLogo.png";
import { API_URL } from "../../url/api";

type Props = {
  onBack: () => void;
};

const ForgotPassword = (props?: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState<string>("");
  const [success, setSuccess] = React.useState<string>("");

  useEffect(() => {
    checkLoginedIn()
  }, []);

  const checkLoginedIn=()=>{
    const userId = localStorage.getItem("userId");
    const doctorId = localStorage.getItem("doctorId");
    if (userId) 
      window.location.href = "/dashboard/";
    else if (doctorId)
      window.location.href = "doctor/dashboard/";
  }

  const handleSubmit = async (e: React.FormEvent) => {
    if (isLoading) return;
    e.preventDefault();
    if (email === "") {
      setError("Please enter your email");
      return;
    }
    setIsLoading(true);
    await axios
      .post(`${API_URL}forgot-password/`, { email })
      .then((response) => {
        console.log("API call success:", response);
        if (response.data.success) {
          setSuccess("Please check your email to reset the password");
          setError("");
        } else {
          setError(response.data.response || "An error occurred");
          setSuccess("");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("API call failed:", error);
        setError("An error occurred");
        setSuccess("");
        setIsLoading(false);
      });
  };

  const validateEmail = (email: string) => {
    let isValid = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email);

    setEmail(email);
    if (email === "") setError("Please enter your email");
    else if (isValid) setError("");
    else setError("Please enter a valid email");
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-200 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md ">
          <img className="mx-auto h-12 w-auto" src={logo} alt="Outss Logo" />
          <h2 className="mt-6 text-center text-xl leading-9 font-extrabold text-gray-900">
            Forgot Password / Reset Password
          </h2>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 mx-4 md:mx-0 rounded-lg shadow sm:px-10">
            <div className="text-green-500 text-sm mb-4 text-center">
              {success}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-200 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md ">
        <img className="mx-auto h-12 w-auto" src={logo} alt="Outss Logo" />
        <h2 className="mt-6 text-center text-lg leading-9 font-bold text-gray-900">
          Forgot Password / Reset Password
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 mx-4 md:mx-0 rounded-lg shadow sm:px-10">
          <form className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email address
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => validateEmail(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                />
              </div>
            </div>

            {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

            <div>
              <button
                type="submit"
                disabled={isLoading || error !== ""}
                onClick={handleSubmit}
                className="w-full flex justify-center disabled:opacity-70 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>

            <div className="flex items-center justify-between">
              <div className="text-sm leading-5">
                <a
                  href="#"
                  onClick={() => props?.onBack()}
                  className="font-medium text-primary hover:text-primary focus:outline-none focus:underline"
                >
                  Back to Login
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
